module.exports = __webpack_public_path__ + "img/icon-station.8a1b9cca.svg";